<template>
  <NuxtLayout name="base">
    <template #navigation>
      <BaseNavigationBar
        :title="t('Назад')"
        :fallback-route="permissions.WORKSPACE.ROUTE"
      />
    </template>

    <div class="consent-page">
      <!-- Legal Pages Navigation -->
      <nav class="legal-nav">
        <NuxtLink
          :to="permissions.LEGAL.PRIVACY.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.PRIVACY.ROUTE }"
        >
          Политика конфиденциальности
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.CONSENT.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.CONSENT.ROUTE }"
        >
          Согласие на обработку данных
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.COOKIES.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.COOKIES.ROUTE }"
        >
          Политика cookies
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.ADVERTISING.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.ADVERTISING.ROUTE }"
        >
          Согласие на рекламу
        </NuxtLink>
      </nav>

      <h1 class="consent-page__title">
        СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
      </h1>

      <div class="consent-page__intro">
        <p>Я, физическое лицо, заполняющее веб-форму на сайте <a href="https://prod.new.queststore.space/" target="_blank">https://prod.new.queststore.space/</a> (далее - «Сайт»), настоящим свободно, своей волей и в своем интересе выражаю согласие Обществу с ограниченной ответственностью «Квест Проекты» (ОГРН 1247700644069, ИНН 9728142014, адрес: 117588, г. Москва, Новоясеневский пр-кт, д. 11, далее – «Оператор») на обработку моих персональных данных, в том числе с использованием автоматизированных средств, в целях, указанных ниже:</p>
      </div>

      <section class="consent-page__section">
        <h2>1. Состав персональных данных</h2>
        <p>1.1. Согласие предоставляется на обработку следующих персональных данных:</p>
        <ul>
          <li>фамилия, имя, отчество;</li>
          <li>номер телефона;</li>
          <li>адрес электронной почты (email);</li>
          <li>адрес места жительства/пребывания;</li>
          <li>история запросов и просмотров на Сайте;</li>
          <li>данные о действиях пользователя, сведения о местоположении, IP-адрес, тип устройства и браузера, дата и время визитов;</li>
          <li>cookie-файлы и иные аналогичные данные.</li>
        </ul>
        <p>1.2. Также, в случае авторизации через Единую систему идентификации и аутентификации (ЕСИА, Госуслуги), обрабатываются: данные, переданные через ЕСИА: ФИО, СНИЛС, адрес эл. почты, номер телефона и иные доступные идентификационные сведения в соответствии с условиями интеграции с ЕСИА.</p>
      </section>

      <section class="consent-page__section">
        <h2>2. Цели обработки персональных данных</h2>
        <p>2.1. Персональные данные обрабатываются в следующих целях:</p>
        <ul>
          <li>предоставление доступа к Сайту, его функционалу и сервисам;</li>
          <li>регистрация и идентификация пользователя на Сайте;</li>
          <li>обработка запросов и заявок;</li>
          <li>обеспечение обратной связи (включая отправку уведомлений, писем и СМС-сообщений);</li>
          <li>участие в акциях, опросах, интервью, тестированиях и исследованиях;</li>
          <li>направление информации рекламного и информационного характера (при наличии отдельного согласия);</li>
          <li>проведение статистических и иных исследований при условии обезличивания данных.</li>
        </ul>
      </section>

      <section class="consent-page__section">
        <h2>3. Категория обработки</h2>
        <p>3.1. Обработка осуществляется смешанным способом (автоматизированным и неавтоматизированным), включая действия: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение.</p>
      </section>

      <section class="consent-page__section">
        <h2>4. Срок хранения и условия</h2>
        <p>4.1. Согласие действует в течение 5 (пяти) лет с момента его предоставления.</p>
        <p>4.2. Согласие может быть отозвано мною в любой момент путем направления письменного уведомления на электронную почту Оператора.</p>
        <p>4.3. При отзыве согласия Оператор прекращает обработку персональных данных, за исключением случаев, предусмотренных законодательством РФ.</p>
      </section>

      <section class="consent-page__section">
        <h2>5. Передача третьим лицам</h2>
        <p>5.1. Оператор вправе поручать обработку персональных данных третьим лицам по договору, при условии соблюдения ими требований законодательства о защите ПДн.</p>
        <p>Также данные могут передаваться: хостинг-провайдерам, CRM-системам, операторам связи, маркетинговым платформам — в рамках целей, указанных выше.</p>
      </section>

      <section class="consent-page__section">
        <h2>6. Прочее</h2>
        <p>Я подтверждаю, что ознакомлен(а) с Политикой конфиденциальности и Политикой обработки cookie-файлов, размещёнными на Сайте.</p>
        <p>Я подтверждаю, что мне понятны мои права, установленные ст. 9 и 14 Федерального закона № 152-ФЗ, в том числе право на отзыв согласия, доступ к своим данным, внесение изменений и т. д.</p>
      </section>

      <div class="consent-page__footer">
        <p class="consent-page__date">
          Дата последнего обновления: {{ new Date().toLocaleDateString('ru-RU') }}
        </p>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { permissions } from '~/shared/lib'
import { BaseNavigationBar } from '~/shared/ui'

import i18n from '../model/ConsentPage.i18n.json'

const { t } = useI18n(i18n)

definePageMeta({
  layout: 'base',
})
</script>

<style scoped lang="scss">
.legal-nav {
  display: flex;
  flex-wrap: wrap;
  gap: rem(8px);
  margin-bottom: rem(32px);
  padding: rem(16px);
  background-color: #f8f9fa;
  border-radius: rem(8px);
  border: 1px solid #e9ecef;

  &__item {
    padding: rem(8px) rem(16px);
    border-radius: rem(20px);
    border: 1px solid #dee2e6;
    background-color: #fff;
    color: #6c757d;
    text-decoration: none;
    font-size: rem(14px);
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
    }

    &--active {
      background-color: #007bff;
      color: #fff;
      border-color: #007bff;

      &:hover {
        background-color: #0056b3;
        border-color: #0056b3;
      }
    }
  }
}

@media (width <= 768px) {
  .legal-nav {
    padding: rem(12px);
    gap: rem(6px);

    &__item {
      padding: rem(6px) rem(12px);
      font-size: rem(12px);
    }
  }
}

.consent-page {
  max-width: rem(800px);
  margin: 0 auto;
  padding: rem(48px);
  background-color: #fff;
  border-radius: rem(8px);

  &__title {
    font-size: rem(32px);
    font-weight: 700;
    margin-bottom: rem(16px);
    color: #1a1a1a;
  }

  &__intro {
    margin-bottom: rem(32px);

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
    }

    a {
      color: #06c;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__section {
    margin-bottom: rem(40px);

    h2 {
      font-size: rem(24px);
      font-weight: 600;
      margin-bottom: rem(16px);
      color: #1a1a1a;
    }

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
      margin-bottom: rem(12px);
    }

    ul {
      list-style-type: disc;
      margin-left: rem(24px);
      margin-bottom: rem(16px);

      li {
        font-size: rem(16px);
        line-height: 1.6;
        color: #333;
        margin-bottom: rem(8px);
      }
    }
  }

  &__footer {
    margin-top: rem(48px);
    padding-top: rem(24px);
    border-top: 1px solid #e0e0e0;
  }

  &__agreement,
  &__identifier {
    font-size: rem(16px);
    color: #333;
    margin-bottom: rem(12px);
    font-weight: 500;
  }

  &__date {
    font-size: rem(14px);
    color: #666;
    text-align: center;
    margin-top: rem(24px);
  }
}

@media (width <= 768px) {
  .consent-page {
    padding: rem(32px) rem(24px);

    &__title {
      font-size: rem(24px);
    }

    &__section {
      h2 {
        font-size: rem(20px);
      }
    }
  }
}
</style>
